<template>

  <ChecklistReport />

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import ChecklistReport from "@/views/modules/checklist/Report/ChecklistReport";
export default {
  mixins: [pageDefaultMixin],
  components: {ChecklistReport},
  name: 'ConsorcioLmmChecklistReport',
  data() {
    return {
      path: "checklist/report",//OBRIGATÓRIO MESMO EM SOBREPOSIÇÕES
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },

}
</script>
